import React from 'react';
import withAuth from 'sections/services-marketplace/experts/sections/with-auth/withAuth';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {
  DisplayText,
  TextContainer,
  TextStyle,
  Stack,
  Button,
  Link,
} from '@shopify/polaris';
import {AppLayout} from 'sections/services-marketplace/experts/components';
import {Routes} from '../../utilities';
import {LoginModal, LoginModalContext} from '../login-modal';
import {GetShopAuthQueryData} from 'sections/services-marketplace/experts/sections/with-auth/graphql/GetShopAuth.graphql';

import styles from './PostAJobCta.scss';

interface OwnProps {
  currentShop: GetShopAuthQueryData.CurrentShop | null;
  currentShopUser: GetShopAuthQueryData.CurrentShopUser | null;
}

type CombinedProps = OwnProps & WithI18nProps;

interface State {
  modalOpen: boolean;
}

class PostAJobCta extends React.PureComponent<CombinedProps, State> {
  state: State = {
    modalOpen: false,
  };

  toggleModal = () => {
    this.setState(({modalOpen}) => ({modalOpen: !modalOpen}));
  };

  renderHeader() {
    const {i18n} = this.props;

    return (
      <TextContainer spacing="tight">
        <DisplayText size="large" element="h2">
          {i18n.translate('Global.PostAJob.title')}
        </DisplayText>
        <DisplayText size="small" element="p">
          <TextStyle variation="subdued">
            {i18n.translate('Global.PostAJob.intro')}
          </TextStyle>
        </DisplayText>
      </TextContainer>
    );
  }

  renderSignupText() {
    const {i18n} = this.props;

    const SignupLink = (
      <Link url={Routes.referralUrl('footer')} external>
        {i18n.translate('Global.PostAJob.domain')}
      </Link>
    );

    return (
      <TextStyle variation="subdued">
        {i18n.translate('Global.PostAJob.signupText', {
          link: SignupLink,
        })}
      </TextStyle>
    );
  }

  render() {
    const {currentShop, i18n} = this.props;
    const {modalOpen} = this.state;

    return (
      <div className={styles.CtaContainer}>
        <AppLayout>
          <AppLayout.Container subdued>
            <div className={styles.Cta}>
              <Stack vertical>
                {this.renderHeader()}
                {currentShop ? (
                  <Button
                    primary
                    external
                    url={Routes.postJobLoginPath({
                      shop: currentShop.permanentDomain,
                    })}
                  >
                    {i18n.translate('Global.Header.navigation.buttonCta')}
                  </Button>
                ) : (
                  <Stack vertical>
                    <Button primary onClick={this.toggleModal}>
                      {i18n.translate('Global.Header.navigation.buttonCta')}
                    </Button>
                    {this.renderSignupText()}
                    <LoginModal
                      context={LoginModalContext.CreateJob}
                      modalText={i18n.translate('Global.PostAJob.modalText')}
                      open={modalOpen}
                      onClose={this.toggleModal}
                    />
                  </Stack>
                )}
              </Stack>
            </div>
          </AppLayout.Container>
        </AppLayout>
      </div>
    );
  }
}

export default withAuth(withI18n()(PostAJobCta));
